<script>
import MonitoringReport from '@/views/pages/monitoring-report/MonitoringReport.vue'

export default {
  name: 'MonitoringReportAdvisor',
  components: { MonitoringReport },
}
</script>

<template>
  <monitoring-report type="monitoringReportAdvisorList" />
</template>

<style scoped>

</style>
